/**
 * @prettier
 */

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { hideModal } from 'cards/actions/modalActions';
import SampleLimitView from 'cards/components/common/SingleSample/SampleLimitView/SampleLimitView';
import { getMultiSampleState } from 'cards/selectors/singlesample';

export const SingleSampleLimitScreenModalBase = ({
  closeModal,
  multiPreviewState,
  setModalOptions,
}) => {
  const count = multiPreviewState.count || { ordersPlaced: 0, maximumOrdersAllowed: 5 };

  const text = (
    <Fragment>
      Looks like you&#39;ve ordered {count.ordersPlaced} out of {count.maximumOrdersAllowed} free
      samples max. Love a design you tried? Place a full order anytime (or try a printed proof
      before you buy!).
    </Fragment>
  );

  return <SampleLimitView text={text} closeModal={closeModal} setModalOptions={setModalOptions} />;
};

export const mapStateToProps = state => ({
  multiPreviewState: getMultiSampleState(state),
});

export const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleSampleLimitScreenModalBase);



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/SingleSampleModal/SingleSampleLimitScreenModal.jsx